<template>
  <v-autocomplete
    v-model="localValue"
    :items="items"
    :label="label"
    :loading="false"
    :search-input.sync="localSearch"
    :item-text="itemText"
    :item-value="itemValue"
    outlined
    class="rounded-pill"
    dense
    :error-messages="errorMessages"
    :disabled="disabled"
    :menu-props="menuProps"
    @input="clearError"
    :key="resetKey"
  >
    <template v-slot:append>
      <v-progress-circular
        v-if="loading"
        indeterminate
        color="primary"
        size="20"
        width="2"
      ></v-progress-circular>
      <v-icon v-else-if="localValue" @click="clearValue">mdi-close</v-icon>
    </template>

    <template v-for="(_, slotName) in $scopedSlots" v-slot:[slotName]="scope">
      <slot :name="slotName" v-bind="scope"></slot>
    </template>
  </v-autocomplete>
</template>

<script>

export default {
  name: 'AutocompleteFilter',
  data() {
    return {
      resetKey: 0
    };
  },
  props: {
    value: {
      type: [String, Number, Object, Array],
      default: ''
    },
    items: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    search: {
      type: [String, null],
      default: ''
    },
    itemText: {
      type: String,
      default: 'name',
    },
    itemValue: {
      type: String,
      default: 'id',
    },
    errorMessages: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
    localSearch: {
      get() {
        return this.search;
      },
      set(newValue) {
        this.$emit('update:search', newValue);
      },
    },
    menuProps() {
      return {
        contentClass: 'autocomplete-filter-menu',
        maxHeight: 300,
      };
    },
  },
  methods: {
    clearError() {
      if (this.errorMessages) {
        this.$emit("clear-error");
      }
    },
    clearValue() {
      this.$emit('input', '');
      this.$emit('update:search', '');

      this.resetKey += 1;

      this.$nextTick(() => {
        const inputElement = this.$el.querySelector('input');
        if (inputElement) {
          inputElement.focus();
        }
      });
    }
  },
};
</script>

<style>
/* Not scoped: v-menu content is appended to <body> outside this component's scope */
.autocomplete-filter-menu .v-list-item__title,
.autocomplete-filter-menu .v-list-item__subtitle {
  white-space: normal !important;
  word-break: break-word;
  overflow: visible;
  text-overflow: clip;
  line-height: 1.35;
}

.autocomplete-filter-menu .v-list-item {
  min-height: 40px;
  height: auto;
}
</style>